import React from 'react'

type Props = {
  children: React.ReactNode
}

type AccordionContextType = {
  open: string[]
  toggleOpen: (id: string) => void
}

export const AccordionContext = React.createContext<AccordionContextType | null>(null)

const AccordionRoot = ({ children }: Props) => {
  const [open, setOpen] = React.useState<string[]>([])

  const toggleOpen = React.useCallback((id: string) => {
    setOpen((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id)
      }
      return [...prev, id]
    })
  }, [])

  const value = React.useMemo(() => ({ open, toggleOpen }), [open, toggleOpen])

  return <AccordionContext.Provider value={value}>{children}</AccordionContext.Provider>
}

export default AccordionRoot
